/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState, useCallback, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { AiOutlinePlus } from 'react-icons/ai';
import { HiOutlineDocumentText } from 'react-icons/hi';
import { useParams } from 'react-router-dom';

import {
  Tab,
  Title,
  Button,
  TabContent,
  WrapperFlex,
  Breadcrumbs,
} from '@unimed-fesp/components';

import history from '../../services/history';
import { Creators as ListaActions } from '../../store/ducks/lista';
import { Creators as ListaInativosActions } from '../../store/ducks/listaInativos';
import { Creators as DocumentoActions } from '../../store/ducks/documento';
import { isAdmin } from '../../utils/userRole';
// #region Import Componentes
import FadeIn from '../../components/atoms/FadeIn';
import DadosLista from '../../components/molecules/DadosLista';
import LoadingSpinning from '../../components/molecules/LoadingSpinning';
import FooterListaInativosAcoes from '../../components/molecules/FooterListaInativosAcoes';
import ModalPesquisaBeneficiario from '../../components/organisms/ModalPesquisaBeneficiario';
import FormSelecionaBeneficiario from '../../components/organisms/FormSelecionaBeneficiario';
import TableHistoricoAlteracoesLista from '../../components/organisms/TableHistoricoAlteracoesLista';
// #endregion

import StatusListaAPIEnum from '../../enums/StatusListaAPIEnum';

import { Container } from './styles';
import theme from '../../styles/theme';

function ListaDetalheInativo() {
  const { idLista } = useParams();
  const dispatch = useDispatch();

  const {
    listaInativos,
    listaGrupoFamiliar,
    listaHistoricoInativos,
  } = useSelector((state) => state.lista.response);
  const { loading } = useSelector((state) => state.lista);
  const { usuario } = useSelector((state) => state.auth);
  const { success: successSalvarBeneficiario } = useSelector(
    (state) => state.lista.postSalvarBeneficiarioInativos
  );
  const { success: successAtualizarStatusLista } = useSelector(
    (state) => state.listaInativos.putListaInativosAtualizarStatus
  );

  // #region Condições
  const IS_ADM = isAdmin(usuario.role) || false;
  const LISTA_SEM_DOCUMENTOS =
    listaInativos?.documentosEnviados && !listaInativos?.hasDocumentos;

  const LISTA_COM_DOCUMENTOS = listaInativos?.hasDocumentos;

  const DOCUMENTOS_OBRIGATORIOS_ENVIADOS = listaInativos?.documentosEnviados;

  const LISTA_TEM_GRUPO_FAMILIAR =
    listaGrupoFamiliar && listaGrupoFamiliar.length > 0;

  const DOCUMENTOS_VALIDADOS = listaInativos?.documentosValidados;

  // #region status
  const EM_ANALISE_DOCUMENTACAO =
    listaInativos?.idStatusLista ===
    StatusListaAPIEnum.returnId.EmAnalisedeDocumentacao;

  const AGUARDANDO_DOCUMENTOS =
    listaInativos?.idStatusLista ===
    StatusListaAPIEnum.returnId.AguardandoDocumentos;

  const PENDENTE_DE_PROCESSAMENTO =
    listaInativos?.idStatusLista ===
    StatusListaAPIEnum.returnId.PendenteProcessamento;

  const PENDENTE_DE_ENVIO =
    listaInativos?.idStatusLista ===
    StatusListaAPIEnum.returnId.PendentedeEnvio;

  const ERRO_DE_PROCESSAMENTO =
    listaInativos?.idStatusLista ===
    StatusListaAPIEnum.returnId.ErrodeProcessamento;

  const PROCESSADA_COM_SUCESSO =
    listaInativos?.idStatusLista ===
    StatusListaAPIEnum.returnId.ProcessadoSucesso;

  const EXCLUIDA =
    listaInativos?.idStatusLista === StatusListaAPIEnum.returnId.Excluida;
  // #endregion
  // #endregion

  const tabs = [
    {
      children: <>beneficiários</>,
      color: '#00995D',
      name: 'beneficiarios',
    },
    {
      children: <>histórico</>,
      color: '#00995D',
      name: 'historico',
    },
  ];

  const [isModalBeneficiariosOpen, setIsModalBeneficiariosOpen] = useState(
    false
  );
  const [disabledButtons, setDisabledButtons] = useState(true);

  const toggleModalConsultaBeneficiarios = useCallback(() => {
    setIsModalBeneficiariosOpen((oldValue) => !oldValue);
  }, []);

  const handleSalvarBeneficiarios = useCallback(() => {
    dispatch(
      ListaActions.postFamiliarRequest(
        listaInativos?.idLista,
        listaGrupoFamiliar
      )
    );
  }, [dispatch, listaGrupoFamiliar, listaInativos?.idLista]);

  const handleAlterarStatusLista = useCallback(
    (idStatus) => {
      dispatch(
        ListaInativosActions.putListaInativosAtualizarStatusRequest(
          idLista,
          idStatus
        )
      );
    },
    [dispatch, idLista]
  );

  const handleEnviarRevisaoDocumentos = useCallback(() => {
    dispatch(
      DocumentoActions.postFinalizarConferenciaDocumentosRequest(
        idLista,
        () => {
          dispatch(ListaActions.getListaInativasRequest(idLista));
          setDisabledButtons(false);
        }
      )
    );
  }, [dispatch, idLista]);

  useEffect(() => {
    dispatch(ListaActions.getListaInativasRequest(idLista));
    setDisabledButtons(false);
  }, [
    dispatch,
    idLista,
    successSalvarBeneficiario,
    successAtualizarStatusLista,
  ]);

  const botoes = useMemo(() => {
    const excluir = {
      isRender:
        !PROCESSADA_COM_SUCESSO &&
        !EXCLUIDA &&
        (IS_ADM || !PENDENTE_DE_PROCESSAMENTO),
      onClick: () => {
        handleAlterarStatusLista(StatusListaAPIEnum.returnId.Excluida);
        setDisabledButtons(true);
      },
    };

    const salvar = {
      isRender: false,
      onClick: () => {
        handleSalvarBeneficiarios();
        setDisabledButtons(true);
      },
    };

    const erroProcessamento = {
      isRender: false,
      onClick: () => {
        handleAlterarStatusLista(
          StatusListaAPIEnum.returnId.ErrodeProcessamento
        );
        setDisabledButtons(true);
      },
    };

    const processadaSucesso = {
      isRender: false,
      onClick: () => {
        handleAlterarStatusLista(StatusListaAPIEnum.returnId.ProcessadoSucesso);
        setDisabledButtons(true);
      },
    };

    const conferirDocumentos = {
      isRender:
        IS_ADM &&
        LISTA_COM_DOCUMENTOS &&
        LISTA_TEM_GRUPO_FAMILIAR &&
        !DOCUMENTOS_VALIDADOS &&
        PENDENTE_DE_PROCESSAMENTO,
      onClick: () => {
        handleAlterarStatusLista(
          StatusListaAPIEnum.returnId.EmAnalisedeDocumentacao
        );
        setDisabledButtons(true);
      },
    };

    const enviarRevisaoDocumentos = {
      isRender:
        IS_ADM &&
        LISTA_COM_DOCUMENTOS &&
        LISTA_TEM_GRUPO_FAMILIAR &&
        EM_ANALISE_DOCUMENTACAO,
      onClick: () => {
        handleEnviarRevisaoDocumentos();
        setDisabledButtons(true);
      },
    };

    const enviarProcessamento = {
      isRender: false,
      onClick: () => {
        handleAlterarStatusLista(
          StatusListaAPIEnum.returnId.PendenteProcessamento
        );
        setDisabledButtons(true);
      },
    };

    if (LISTA_SEM_DOCUMENTOS) {
      enviarProcessamento.isRender =
        !IS_ADM &&
        LISTA_TEM_GRUPO_FAMILIAR &&
        (PENDENTE_DE_ENVIO || ERRO_DE_PROCESSAMENTO);

      processadaSucesso.isRender = IS_ADM && PENDENTE_DE_PROCESSAMENTO;

      erroProcessamento.isRender = IS_ADM && PENDENTE_DE_PROCESSAMENTO;

      salvar.isRender =
        !IS_ADM &&
        LISTA_TEM_GRUPO_FAMILIAR &&
        (PENDENTE_DE_ENVIO || ERRO_DE_PROCESSAMENTO);
    } else {
      enviarProcessamento.isRender =
        !IS_ADM &&
        LISTA_TEM_GRUPO_FAMILIAR &&
        (DOCUMENTOS_OBRIGATORIOS_ENVIADOS || DOCUMENTOS_VALIDADOS) &&
        (AGUARDANDO_DOCUMENTOS || ERRO_DE_PROCESSAMENTO);

      processadaSucesso.isRender =
        IS_ADM && PENDENTE_DE_PROCESSAMENTO && DOCUMENTOS_VALIDADOS;

      erroProcessamento.isRender =
        IS_ADM && PENDENTE_DE_PROCESSAMENTO && DOCUMENTOS_VALIDADOS;

      salvar.isRender =
        !IS_ADM &&
        LISTA_TEM_GRUPO_FAMILIAR &&
        (AGUARDANDO_DOCUMENTOS || ERRO_DE_PROCESSAMENTO);
    }

    return {
      excluir,
      salvar,
      erroProcessamento,
      processadaSucesso,
      conferirDocumentos,
      enviarProcessamento,
      enviarRevisaoDocumentos,
    };
  }, [
    PROCESSADA_COM_SUCESSO,
    EXCLUIDA,
    IS_ADM,
    LISTA_SEM_DOCUMENTOS,
    PENDENTE_DE_PROCESSAMENTO,
    LISTA_COM_DOCUMENTOS,
    PENDENTE_DE_ENVIO,
    LISTA_TEM_GRUPO_FAMILIAR,
    AGUARDANDO_DOCUMENTOS,
    ERRO_DE_PROCESSAMENTO,
    DOCUMENTOS_OBRIGATORIOS_ENVIADOS,
    EM_ANALISE_DOCUMENTACAO,
    handleAlterarStatusLista,
    handleSalvarBeneficiarios,
    handleEnviarRevisaoDocumentos,
  ]);

  if (loading)
    return (
      <WrapperFlex fullWidth alignCenter justifyCenter minHeight={400}>
        <FadeIn>
          <LoadingSpinning />
        </FadeIn>
      </WrapperFlex>
    );

  return (
    <Container>
      <WrapperFlex justifySpaceBetween>
        <FadeIn>
          <Title
            text={`lista: ${listaInativos?.nmLista || ''}`}
            color={theme.titleGray}
            fontSize={38}
            marginBottom={8}
          />
          <Breadcrumbs
            crumbs={[
              { path: 'novo' },
              {
                path: 'listas',
                onNavigate: () => history.push('/novo/lista'),
              },
            ]}
          />
        </FadeIn>
        {((IS_ADM && EM_ANALISE_DOCUMENTACAO) ||
          (!IS_ADM && LISTA_COM_DOCUMENTOS && LISTA_TEM_GRUPO_FAMILIAR)) && (
          <Button
            onClick={() => {
              history.push(
                `/novo/listainativo/${listaInativos?.idLista}/documentos`
              );
            }}
          >
            <HiOutlineDocumentText color="#FFFF" style={{ marginRight: 5 }} />
            lista de documentos
          </Button>
        )}
      </WrapperFlex>

      <DadosLista lista={listaInativos} />

      <WrapperFlex marginTop={30}>
        <Tab tabs={tabs}>
          <TabContent contentForTab="beneficiarios">
            <WrapperFlex column>
              {!IS_ADM &&
                ((LISTA_SEM_DOCUMENTOS &&
                  (PENDENTE_DE_ENVIO || ERRO_DE_PROCESSAMENTO)) ||
                  (LISTA_COM_DOCUMENTOS &&
                    (AGUARDANDO_DOCUMENTOS ||
                      (PENDENTE_DE_ENVIO && !LISTA_TEM_GRUPO_FAMILIAR) ||
                      ERRO_DE_PROCESSAMENTO))) && (
                  <WrapperFlex justifyEnd marginBottom={15}>
                    <Button
                      tipo="primary"
                      alignEnd
                      paddingTop={10}
                      paddingRight={10}
                      marginRight={1}
                      align-items="flex-end"
                      justify="flex-end"
                      justifySpaceBetween
                      width={124}
                      font="16px unimed_slabregular"
                      onClick={toggleModalConsultaBeneficiarios}
                    >
                      <AiOutlinePlus color="#FFFF" />
                      Adicionar
                    </Button>
                  </WrapperFlex>
                )}
              <FormSelecionaBeneficiario
                readOnly={
                  !(
                    !IS_ADM &&
                    ((LISTA_SEM_DOCUMENTOS &&
                      (PENDENTE_DE_ENVIO || ERRO_DE_PROCESSAMENTO)) ||
                      (LISTA_COM_DOCUMENTOS &&
                        (AGUARDANDO_DOCUMENTOS ||
                          (PENDENTE_DE_ENVIO && !LISTA_TEM_GRUPO_FAMILIAR) ||
                          ERRO_DE_PROCESSAMENTO)))
                  )
                }
              />
            </WrapperFlex>
          </TabContent>
          <TabContent contentForTab="historico">
            <TableHistoricoAlteracoesLista
              historicoAlteracoes={listaHistoricoInativos}
            />
          </TabContent>
        </Tab>
      </WrapperFlex>

      <WrapperFlex marginTop={30}>
        <FooterListaInativosAcoes
          {...botoes}
          disabledButtons={disabledButtons}
        />
      </WrapperFlex>

      <ModalPesquisaBeneficiario
        isOpen={isModalBeneficiariosOpen}
        onCloseModal={toggleModalConsultaBeneficiarios}
      />
    </Container>
  );
}

export default ListaDetalheInativo;
